import styled from '@emotion/styled'
import Link from 'next/link'

import Button from '../../Button'
import BetaBadge from 'components/BetaBadge'
import { Card } from 'components/FeatureCard'
import { FeatureItem, FeaturesList } from 'components/FeaturesList'
import { LiveChatLogoIcon, NotificationIcon, UserSwitchIcon } from 'components/icons'
import { useTracking } from 'hooks/useTracking'
import { LIVECHAT_BETA_BADGE_TOOLTIP_TEXT, LiveChatIntegrationUrls } from 'lib/constants'
import { EVENT_NAMES } from 'lib/tracking'

const StyledCard = styled(Card)`
	position: relative;
`

const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

const Title = styled.p`
	${({ theme }) => theme.typography.paragraphMedium};
	color: ${({ theme }) => theme.colors.light.primaryTextColor};
	margin: 0;
	display: flex;
	align-items: center;
	gap: ${({ theme }) => theme.spaces.space3};
`

const ManageButton = styled(Button)`
	font-weight: 600;
	padding: ${({ theme }) => (theme.isMobile ? theme.spaces.space2 : theme.spaces.space3)};
	background-color: ${({ theme }) => theme.colors.light.surfaceDecorative};
	border-radius: ${({ theme }) => theme.borderRadiuses.md};
`

const BaseLink = styled(Link)`
	text-decoration: none;
	margin-left: auto;
`

const ColorResetLink = styled(Link)`
	color: inherit;
`

function LiveChatIntegrationCard() {
	const track = useTracking()

	return (
		<StyledCard data-testid="livechat-integration-card">
			<Header>
				<Title>
					Chat <BetaBadge withIcon tooltipText={LIVECHAT_BETA_BADGE_TOOLTIP_TEXT} />
				</Title>
				<BaseLink href="/configurator/widget-content/livechat">
					<ManageButton
						kind="secondary"
						type="button"
						onClick={() => track(EVENT_NAMES.LIVECHAT_MANAGE_CLICKED)}
						mediumDesktop
					>
						Manage
					</ManageButton>
				</BaseLink>
			</Header>
			<FeaturesList>
				<FeatureItem>
					<LiveChatLogoIcon />
					<span>Chat experience powered by LiveChat</span>
				</FeatureItem>
				<FeatureItem>
					<NotificationIcon />
					<span>Customers get notified about new messages</span>
				</FeatureItem>
				<FeatureItem>
					<UserSwitchIcon />
					<span>
						Set up your availability in{' '}
						<ColorResetLink href={LiveChatIntegrationUrls.SETTINGS_AVAILABILITY} target="_blank" rel="noopener">
							LiveChat Settings{`->`}
						</ColorResetLink>
					</span>
				</FeatureItem>
			</FeaturesList>
		</StyledCard>
	)
}

export default LiveChatIntegrationCard
